import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ResponsiveContainer, ResponsiveContent } from '../ui/ResponsiveLayout';
import BrandSymbol from '../ui/BrandSymbol';

const ExecutorComingSoon: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const ownerName = location.state?.ownerName || 'the estate owner';

  return (
    <ResponsiveContainer background="stone">
      <ResponsiveContent>
        <div className="max-w-3xl mx-auto py-8">
          {/* Header */}
          <div className="flex flex-col items-center justify-center w-full mb-8">
            <BrandSymbol size="4xl" variant="dark" showText={true} className="mb-6" />
          </div>

          {/* Main Content Card */}
          <div className="bg-white rounded-2xl shadow-lg border border-stone-200 overflow-hidden">
            {/* Top Banner */}
            <div className="bg-gradient-to-r from-cyan-700 to-cyan-600 px-8 py-6 text-center">
              <h1 className="text-2xl md:text-3xl font-display font-semibold text-white">
                Coming Soon!
              </h1>
            </div>

            {/* Content */}
            <div className="px-8 py-10">
              {/* Message */}
              <p className="text-lg text-stone-700 text-center mb-8 leading-relaxed max-w-xl mx-auto">
                We're currently building an <span className="font-semibold text-cyan-700">Executor Portal</span> that 
                will allow you to securely view <span className="font-semibold">{ownerName}'s</span> End of an Era 
                plan when the time comes. You'll receive a separate email with access details once the portal is ready.
              </p>

              {/* Image */}
              <div className="flex justify-center mb-10">
                <div className="bg-stone-50 rounded-xl border border-stone-200 p-4 max-w-2xl w-full">
                  <img 
                    src="/images/executor-portal-preview.png" 
                    alt="Executor Portal Preview" 
                    className="w-full rounded-lg shadow-sm"
                    onError={(e) => {
                      // Fallback if image doesn't load
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      target.parentElement!.innerHTML = `
                        <div class="bg-gradient-to-br from-stone-100 to-stone-200 rounded-lg p-12 text-center">
                          <svg class="w-24 h-24 text-stone-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                          <p class="text-stone-500 font-medium">Executor Portal Dashboard</p>
                          <p class="text-stone-400 text-sm mt-1">Preview coming soon</p>
                        </div>
                      `;
                    }}
                  />
                </div>
              </div>

              {/* Divider */}
              <div className="flex items-center gap-4 mb-8">
                <div className="flex-1 h-px bg-stone-200"></div>
                <span className="text-sm text-stone-400">In the meantime</span>
                <div className="flex-1 h-px bg-stone-200"></div>
              </div>

              {/* CTA */}
              <div className="text-center">
                <p className="text-stone-600 mb-4">
                  Feel free to use our estate planner to organize your own legacy.
                </p>
                <button
                  onClick={() => navigate('/frame-140')}
                  className="inline-flex items-center gap-2 px-8 py-3 bg-cyan-700 text-white rounded-lg font-medium hover:bg-cyan-800 transition-colors shadow-sm"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  Go to My Estate Planner
                </button>
                <div className="flex items-center justify-between mt-4">
                  <button
                    onClick={() => navigate('/estate-selector')}
                    className="text-sm text-stone-500 hover:text-cyan-700 flex items-center gap-1"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    Back to Estate Selection
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Help text */}
          <p className="text-center text-sm text-stone-500 mt-6">
            Questions? <a href="mailto:support@endofanera.ai" className="text-cyan-700 hover:underline">Contact Support</a>
          </p>
        </div>
      </ResponsiveContent>
    </ResponsiveContainer>
  );
};

export default ExecutorComingSoon;

